export const CANADA = 'Canada';
export const USA = 'USA';
export const FINANCING_HANDBOOK = 'FinancingHandbook';
export const ERR_PDF_INNERHTML =
    '<h1>Failed to load PDF</h1><p>Please try again later.</p>';
export const HANDBOOK_BRANDS = [
    'vw',
    'audi',
    'bentley',
    'lamborghini',
    'ducati',
];
export const NUMBER_ZERO = 0;
export const NUMBER_TWO = 2;
export const NUMBER_FIVE = 5;
export const NUMBER_ONE = 1;
